export default __webpack_public_path__ + "static/media/42.6854cb7b.png";